import React, { useEffect, useState } from 'react';
import { verifyPolicySignature } from '../signing';

function CryptoSignaturePanel({ sig }) {
    const [ok, setOk] = useState(null);

    useEffect(() => {
        if (!sig || !sig.signature || !sig.payload || !sig.publicKey) {
            setOk(false);
            return;
        }
        verifyPolicySignature({
            payload: sig.payload,
            signature: sig.signature,
            publicKeySpki: sig.publicKey
        }).then(setOk);
    }, [sig]);

    if (!sig) return null;

    const name = sig.signerName || sig.managerName || 'Unknown signer';
    const email = sig.signerEmail || sig.managerEmail || '';
    const crypto = !!(sig.signature && sig.payload && sig.publicKey);

    return (
        <div className="border p-2 mt-2" style={{ borderColor: crypto && ok ? '#16a34a' : '#00bcd4', borderRadius: 8, background: '#f8fafc' }}>
            <div style={{ fontFamily: 'cursive', fontSize: 18, color: '#1a237e' }}>{name}</div>
            <div style={{ fontSize: 12, color: '#334155' }}>{email}{sig.signerRole ? ' · ' + sig.signerRole : ''}</div>
            <div style={{ fontSize: 11, color: '#64748b' }}>
                {crypto ? (ok ? 'ECDSA P-256 signature verified' : ok === false ? 'Signature could not be verified' : 'Checking signature…') : 'Legacy stamp — not a cryptographic signature'}
            </div>
            <div style={{ fontSize: 10, fontFamily: 'ui-monospace, Consolas, monospace', wordBreak: 'break-all', color: '#475569' }}>
                {sig.signedAt || sig.timestamp || ''}<br />
                ID {sig.signatureId}<br />
                {sig.payloadHash ? 'Hash ' + sig.payloadHash : ''}
                {sig.fingerprint ? <><br />Key {sig.fingerprint}</> : null}
            </div>
        </div>
    );
}

export default CryptoSignaturePanel;
